// import ARScene from "./components/ARScene";
import MindARComponent from "./components/MindARComponent";
import SelectedGamePage from "./components/SelectedGamePage";
import LandingPage from "./components/LandingPage";
import PagePrivacyPolicy from "./components/PagePrivacyPolicy";

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Initialize Google Analytics only in production
if (process.env.REACT_APP_ENV === 'PROD') {
  const TRACKING_ID = 'G-K5FMNDXR81';
  ReactGA.initialize(TRACKING_ID);
}

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/game/:game_id" element={<SelectedGamePage />} />
          <Route path="/camera" element={<MindARComponent />} />
          <Route path="/data-privacy" element={<PagePrivacyPolicy />} />
        </Routes>
    </BrowserRouter>



  );
}

export default App;
